// extracted by mini-css-extract-plugin
export default {"header":"qSFgAZR8","mobile":"mobile","fullwidth":"XoAGlrVn","headerLeft":"WAM94BTW","promo":"CtMKSQTO","controls":"DfmS9S5X","overlay":"o9MUZ3fA"};